export default "__VITE_ASSET__C$7nJ38t__"